import { useFormikContext } from 'formik';
import React, { FC, useEffect } from 'react';
import Label from '../../components/label/label';
import Togglebox from '../../components/togglebox/togglebox';
import { addCustomFieldMetaData } from '../../utilities/formFields';
import { generateFieldId } from '../../utilities/GenerateFieldId';

interface SettingToggleFieldProps {
    accessor: string;
    displayName: string | undefined;
    isCard?: boolean;
    detailTypeId?: number;
    height?: string | undefined;
}

export const SettingToggleField: FC<SettingToggleFieldProps> = ({ accessor, displayName, isCard, detailTypeId = undefined, height }) => {
    const { values, setFieldValue } = useFormikContext();

    useEffect(() => {
        addCustomFieldMetaData(detailTypeId, values, accessor, setFieldValue, true);
    }, [])

    return <div className={`${isCard ? '' : 'flex flex-col flex-1 pr-6'} mb-2`} style={height ? { height: height } : {}}>
        <div className="flex flex-row justify-between" id = {generateFieldId(accessor, 'ToggleFieldLabel')}>
            <Label htmlFor={accessor}
                className="text-xs text-gray-600 mt-1 my-1">{displayName}:</Label>
        </div>
        <div className="flex flex-row justify-between" id={generateFieldId(accessor, 'ToggleField')}>
            <Togglebox name={accessor} label=""></Togglebox>
        </div>
    </div>;
};
